import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Home = () => {
  const { currentUser } = useAuth();

  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-lg-8 mx-auto text-center">
          <h1 className="display-4">Plataforma WintonCoin</h1>
          <p className="lead mb-4">
            Una plataforma para publicar y realizar tareas con pagos basados en tokens BLUE.
          </p>

          <div className="d-grid gap-3 d-sm-flex justify-content-sm-center">
            {currentUser ? (
              <>
                <Link to="/tasks" className="btn btn-primary btn-lg">
                  Ver Tareas Disponibles
                </Link>
                <Link to="/tasks/create" className="btn btn-outline-primary btn-lg">
                  Publicar una Tarea
                </Link>
              </>
            ) : (
              <>
                <Link to="/login" className="btn btn-primary btn-lg">
                  Iniciar Sesión
                </Link>
                <Link to="/register" className="btn btn-outline-primary btn-lg">
                  Registrarse
                </Link>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="row mt-5">
        <div className="col-md-4">
          <div className="card mb-4">
            <div className="card-body text-center">
              <h3>Publica Tareas</h3>
              <p>Crea tareas cuando necesites ayuda y paga con tokens BLUE.</p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card mb-4">
            <div className="card-body text-center">
              <h3>Realiza Trabajos</h3>
              <p>Completa tareas y gana tokens BLUE que tendras disponibles en tu cartera.</p>
            </div>
          </div>
        </div>
        <div className="col-md-4">
          <div className="card mb-4">
            <div className="card-body text-center">
              <h3>Paga con BLUE Tokens</h3>
              <p>Puedes pagar con tokens BLUE en la plataforma.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
